export default {
  pt: {
    title: "Verificação de propriedade",
    description: "Esta nota fiscal possui um destinatário diferente CPF do segurado. Informe a relação entre o destinatário e o segurado.",
    spouseOption: "O destinatário é cônjuge, descendente ou ascendente",
    thirdPartyOption: "O destinatário é um terceiro",
    sendButton: "Enviar",
  },
  en: {
    title: "Property verification",
    description: "This invoice has a recipient with a different CPF than the insured. Please inform the relationship between the recipient and the insured.",
    spouseOption: "The recipient is a spouse, descendant or ascendant",
    thirdPartyOption: "The recipient is a third party",
    sendButton: "Send",
  },
}; 